import { useTranslation } from 'next-i18next'

const translateConfigValue = <V>(value: V, t: (val: string) => string): V => {
  if (typeof value === 'string') {
    const translationRegex = /^t\((.*)\)$/gm

    const res = translationRegex.exec(value)
    if (res && res[1]) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return t(res[1])
    } else {
      return value
    }
  }

  if (Array.isArray(value)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return value.map((val) => translateConfigValue(val, t))
  }

  if (typeof value === 'object') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return Object.keys(value).reduce((acc, key) => {
      acc[key] = translateConfigValue(value ? value[key] : null, t)
      return acc
    }, {})
  }

  return value
}

const useComponentConfig = <T>(baseConfig: T, translationKey = 'common'): T => {
  const { t } = useTranslation(translationKey)

  return translateConfigValue(baseConfig, t)
}

export default useComponentConfig
export { translateConfigValue }
